import React, { useEffect } from 'react';

function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export default function ModalShell({
  title,
  onClose,
  children,
  className = '',
  closeLabel = 'Zamknij okno',
}) {
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === 'Escape') {
        onClose();
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={joinClassNames('modal', className)}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        {title && (
          <div className="modal-header">
            <h2>{title}</h2>
            <button type="button" className="modal-close" onClick={onClose} aria-label={closeLabel}>
              ✕
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}